import {
	ADD_REMOVE_ITEM,
	CREATE_LIST,
	DELETE_LIST,
	FETCH_TREE,
	FETCH_LISTS,
	SET_ACCOUNTS,
	SET_BANNER,
	SET_CURRENT_LIST,
	SET_EXPANDED,
	UPDATE_LIST,
} from './constants';

export function fetchTree() {
	return {
		type: FETCH_TREE,
	};
}

export function fetchLists() {
	return {
		type: FETCH_LISTS,
	};
}

export function createList(name, list) {
	return {
		type: CREATE_LIST,
		payload: {
			name: name,
			list: list,
		},
	};
}

export function deleteList(id) {
	return {
		type: DELETE_LIST,
		payload: {
			id: id,
		},
	};
}

export function updateList(id, body) {
	return {
		type: UPDATE_LIST,
		id: id,
		payload: body,
	};
}

export function setCurrentList(id, isFirstLoad) {
	return {
		type: SET_CURRENT_LIST,
		payload: {
			id: id,
			isFirstLoad: isFirstLoad,
		},
	};
}
export function setExpanded(expanded) {
	return {
		type: SET_EXPANDED,
		payload: expanded,
	};
}

export function addRemoveItemAction(listId, distList) {
	return {
		type: ADD_REMOVE_ITEM,
		id: listId,
		payload: distList,
	};
}

export function showBannerMessage(message, type, autoDismiss) {
	return {
		type: SET_BANNER,
		payload: {
			message: message,
			type: type,
			autoDismiss: autoDismiss,
		},
	};
}

export function clearBannerMessage() {
	return showBannerMessage('', '', false);
}

export function setAccounts(accounts) {
	return {
		type: SET_ACCOUNTS,
		payload: accounts,
	};
}
